import { gql } from "@apollo/client";
import {
  CashMovementDeepNestingFragment,
  CashMovementNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
  TerminalClosureDeepNestingFragment,
  TerminalClosureNoNestingFragment,
  TerminalClosurePaymentMethodSummaryDeepNestingFragment,
  TerminalClosurePaymentTotalDeepNestingFragment,
  TerminalClosureSalesSummaryDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const MUTATION_OPEN_TERMINAL_SHIFT = gql`
  ${TerminalClosureNoNestingFragment}
  mutation OpenTerminalShift($input: OpenTerminalInput!) {
    openTerminal(input: $input) {
      ...TerminalClosureNoNesting
    }
  }
`;

export const MUTATION_CLOSE_TERMINAL_SHIFT = gql`
  ${TerminalClosureNoNestingFragment}
  mutation CloseTerminalShift($input: CloseTerminalInput!) {
    closeTerminal(input: $input) {
      ...TerminalClosureNoNesting
    }
  }
`;

export const MUTATION_CREATE_CASH_MOVEMENT = gql`
  ${CashMovementNoNestingFragment}
  mutation CreateCashMovement($input: CashMovementInput!) {
    createCashMovement(input: $input) {
      ...CashMovementNoNesting
    }
  }
`;

export const QUERY_TERMINAL_SHIFT = gql`
  ${TerminalClosureDeepNestingFragment}
  ${TerminalClosurePaymentTotalDeepNestingFragment}
  ${CashMovementDeepNestingFragment}
  ${TerminalClosureSalesSummaryDeepNestingFragment}
  ${TerminalClosurePaymentMethodSummaryDeepNestingFragment}
  query GetTerminalClosure($id: ID!) {
    terminalClosure(id: $id) {
      ...TerminalClosureDeepNesting
    }
  }
`;

export const QUERY_TERMINAL_SHIFT_LIST = gql`
  ${TerminalClosureDeepNestingFragment}
  ${TerminalClosurePaymentTotalDeepNestingFragment}
  ${CashMovementDeepNestingFragment}
  ${TerminalClosureSalesSummaryDeepNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  ${TerminalClosurePaymentMethodSummaryDeepNestingFragment}
  query GetTerminalClosures($options: TerminalClosureListOptions) {
    terminalClosures(options: $options) {
      items {
        ...TerminalClosureDeepNesting
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const MUTATION_EMAIL_CLOSURE_SUMMARY = gql`
  mutation EmailClosureSummary($input: EmailClosureSummaryInput!) {
    emailClosureSummary(input: $input) {
      success
    }
  }
`;
